<template>
  <div>
    <label v-if="label" :class="{ 'd-block': inline }" :for="name">{{ label }}</label>
    <div class="form-check" :class="[classname, classObject, {'form-check-inline': inline}]" v-for="option in options" :key="option.value">
      <input type="radio" class="form-check-input" :name="name" :id="option.name" :value="option.value" :checked="option.value === value" v-on:input="updateValue($event.target.value)"/>
      <label class="form-check-label" :for="option.name">{{ option.name }}</label>
    </div>
    <small v-if="helper" class="form-text text-muted">{{ helper }}</small>
    <div v-if="error" class="invalid-feedback animated fadeIn">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    classname: {
      type: String,
    },
    value: {},
    options: {
      type: Array,
      required: true,
    },
    inline: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    helper: {
      type: String,
    },
  },
  computed: {
    error: function () {
      if (this.$parent && this.$parent.errors) {
        if (this.$parent.errors[this.name]) {
          return this.$parent.errors[this.name][0];
        }
      }
    },
    classObject: function () {
      return {
        'is-invalid': this.error ? true : false,
      };
    },
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    },
  },
};
</script>
